import { Component, OnInit, Renderer2 } from "@angular/core";
import { PrintService } from "src/app/shared/services/print.service";
import { Observable } from "rxjs";
import { Cost } from "src/app/shared/models/cost.model";
import { CostAdditionalCodes } from "src/app/shared/models/cost-additional-code.model";
import { tap } from "rxjs/operators";
import { ApprovalStep } from "../../../shared/models/approval-step.model";

@Component({
  selector: "app-cost-print",
  templateUrl: "./cost-print.component.html",
})
export class CostPrintComponent implements OnInit {
  costAdditionalCodes = CostAdditionalCodes;
  costs$: Observable<Cost[]>;
  costs: Cost[];

  constructor(
    private printService: PrintService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.costs$ = this.printService.print$.pipe(
      tap((costs: Cost[]) => (this.costs = costs))
    );
  }

  getMeritoricalApproved(costId: number): ApprovalStep {
    const cost = this.costs.find((v) => v.id === costId);
    if (!cost) {
      return;
    }

    return cost.approvalSteps[cost.approvalSteps.length - 2];
  }

  getFormalApproved(costId: number): ApprovalStep {
    const cost = this.costs.find((v) => v.id === costId);
    if (!cost) {
      return;
    }

    return cost.approvalSteps[cost.approvalSteps.length - 1];
  }

  print(cost: Cost) {
    document.title = cost.docNumber;
    window.print();
  }
}
